/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type QueryAuditsMessageTemplateQueryVariables = {
    id: string;
};
export type QueryAuditsMessageTemplateQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"DialogMessageTemplateAuditRestore_Viewer">;
    } | null;
    readonly messageTemplateById: {
        readonly template: string | null;
        readonly configTemplate: string | null;
        readonly " $fragmentRefs": FragmentRefs<"TypographyMessageTemplateKey_MessageTemplate" | "DialogMessageTemplateAuditRestore_MessageTemplate">;
    } | null;
};
export type QueryAuditsMessageTemplateQuery = {
    readonly response: QueryAuditsMessageTemplateQueryResponse;
    readonly variables: QueryAuditsMessageTemplateQueryVariables;
};



/*
query QueryAuditsMessageTemplateQuery(
  $id: MongoID!
) {
  viewer {
    ...DialogMessageTemplateAuditRestore_Viewer
    id
  }
  messageTemplateById(_id: $id) {
    template
    configTemplate
    ...TypographyMessageTemplateKey_MessageTemplate
    ...DialogMessageTemplateAuditRestore_MessageTemplate
    id
  }
}

fragment DialogMessageTemplateAuditRestore_MessageTemplate on MessageTemplate {
  key
  language
}

fragment DialogMessageTemplateAuditRestore_Viewer on User {
  _id
}

fragment TypographyMessageTemplateKey_MessageTemplate on MessageTemplate {
  key
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configTemplate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryAuditsMessageTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DialogMessageTemplateAuditRestore_Viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MessageTemplate",
        "kind": "LinkedField",
        "name": "messageTemplateById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TypographyMessageTemplateKey_MessageTemplate"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DialogMessageTemplateAuditRestore_MessageTemplate"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueryAuditsMessageTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MessageTemplate",
        "kind": "LinkedField",
        "name": "messageTemplateById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "146182db2672aafdb4bfa75fcf27a04d",
    "id": null,
    "metadata": {},
    "name": "QueryAuditsMessageTemplateQuery",
    "operationKind": "query",
    "text": "query QueryAuditsMessageTemplateQuery(\n  $id: MongoID!\n) {\n  viewer {\n    ...DialogMessageTemplateAuditRestore_Viewer\n    id\n  }\n  messageTemplateById(_id: $id) {\n    template\n    configTemplate\n    ...TypographyMessageTemplateKey_MessageTemplate\n    ...DialogMessageTemplateAuditRestore_MessageTemplate\n    id\n  }\n}\n\nfragment DialogMessageTemplateAuditRestore_MessageTemplate on MessageTemplate {\n  key\n  language\n}\n\nfragment DialogMessageTemplateAuditRestore_Viewer on User {\n  _id\n}\n\nfragment TypographyMessageTemplateKey_MessageTemplate on MessageTemplate {\n  key\n}\n"
  }
};
})();
(node as any).hash = '07624fadc4a13064340e645e0aec273f';
export default node;
